import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { ViewCollectionButton } from "vino/components";
import Image from "vino/components/Image";

const CollectionGridListItem = (props) => {
	const { collection } = props;

	return (
		<div className="product-box">
			<div className="img-wrapper cursor-pointer border-1  flex justify-center">
				<Image className="front" image={collection} />
			</div>
			<div className="product-detail">
				<div>
					<Typography variant="subtitle1" className="font-semibold">
						{collection.name}
					</Typography>
					<Typography variant="subtitle2">{collection.description}</Typography>

					<div className="mt-10 w-full flex justify-center">
						<ViewCollectionButton collectionId={collection.id} />
					</div>
				</div>
			</div>
		</div>
	);
};

CollectionGridListItem.propTypes = {
	collection: PropTypes.object.isRequired,
};

export default CollectionGridListItem;
